import * as React from "react";
import { forwardRef } from "react";
const SvgCheckGreen2 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 15, viewBox: "0 0 19 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.36027 14.5075L0 8.11328L2.33394 5.77934L6.36027 9.77168L16.1659 0L18.4999 2.36793L6.36027 14.5075Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgCheckGreen2);
export default ForwardRef;
